<template>
    <div>
        <h4 v-if="header">{{ header }} - {{ items.length }}</h4>
        <b-nav v-if="showGroupButtons" pills small class="mb-3">
            <b-nav-item @click="groupBy = 'sender'" :active="groupBy === 'sender'">По отправителям</b-nav-item>
            <b-nav-item @click="groupBy = 'courier'" :active="groupBy === 'courier'">По транспортным</b-nav-item>
        </b-nav>
        <div>
            <div v-for="(group, header) in itemsGrouped">
                <button v-b-toggle="_uid + '-places-collapse-' + header" class="collapse-btn w-100">
                    {{ header }} - {{ calcCount(group) }}
                </button>
                <b-collapse :id="_uid + '-places-collapse-' + header">
                    <div class="pl-4">
                        <div v-for="(places, subheader) in group">
                            <button v-b-toggle="_uid + '-places-collapse-' + header + '-' + subheader" @click="$emit('subgroup-click', { header: subheader, places: places })" :class="{ 'collapse-btn_disabled': onlyGroups }" class="collapse-btn w-100">
                                <div>
                                    <div>{{ subheader }} - {{ places.length }}</div>
                                    <small class="text-black-50">Вес: {{ calcWeight(places) }} кг, Объем {{ calcVolume(places) }} м<sup><small>3</small></sup></small>
                                </div>
                            </button>
                            <b-collapse v-if="!onlyGroups" :id="_uid + '-places-collapse-' + header + '-' + subheader">
                                <div class="pl-5">
                                    <div v-for="place in places">
                                        <a href="#" @click="$emit('selected', place)">{{ place.barcode }} ({{ place.shipment.num }})</a>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                </b-collapse>
            </div>
        </div>
    </div>
</template>

<script>
    import CalcPlacesDimensionMixin from "@/components/mixins/CalcPlacesDimensionMixin";
    import GroupItemsMixin from "@/components/mixins/GroupItemsMixin";

    export default {
        name: "PlacesList",

        mixins: [
            CalcPlacesDimensionMixin,
            GroupItemsMixin,
        ],

        props: {
            header: {
                type: String,
                required: false,
                default: '',
            },
            showGroupButtons: {
                type: Boolean,
                required: false,
                default: true,
            },
            groupBy: {
                type: String,
                required: false,
                validator: val => ['sender', 'courier'].indexOf(val) !== -1,
                default: 'sender',
            },
            items: {
                type: Array,
                required: true,
            },
            onlyGroups: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        computed: {
            itemsGrouped() {
                switch (this.groupBy) {
                    case 'courier':
                        return this.groupByFields(this.items, 'shipment.pickUpDate', 'shipment.courierCode');
                    case 'sender':
                    default:
                        return this.groupByFields(this.items, 'shipment.pickUpDate', 'shipment.dlvLogin');
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .collapse-btn {
        display: flex;
        align-items: center;
        color: #333333;
        border: 0;
        background: none;
        outline: none;
        text-align: left;
        padding: 0;

        &:not(.collapse-btn_disabled):before {
            content: '−';
            font-size: 2rem;
            line-height: 2rem;
            display: inline-block;
            margin-right: 0.5rem;
        }

        &:not(.collapse-btn_disabled).collapsed {
            &:before {
                content: '+';
            }
        }
    }
</style>